export default __webpack_public_path__ + "static/media/herbal-medicine.29841312.svg";